import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';
import ArticleReaderModal from '@/components/feature/ArticleReaderModal';
import LearningCompletionPrompt from '@/components/feature/LearningCompletionPrompt';

type ArticleReaderContextValue = {
  openArticle: (slug: string) => void;
  closeArticle: () => void;
};

const ArticleReaderContext = createContext<ArticleReaderContextValue | null>(null);

// eslint-disable-next-line react-refresh/only-export-components -- hook 与 Provider 同文件导出，拆分收益低
export function useArticleReader() {
  const context = useContext(ArticleReaderContext);
  if (!context) {
    throw new Error('useArticleReader must be used within ArticleReaderProvider');
  }
  return context;
}

export default function ArticleReaderProvider({ children }: { children: ReactNode }) {
  const [activeSlug, setActiveSlug] = useState<string | null>(null);

  const openArticle = useCallback((slug: string) => setActiveSlug(slug), []);
  const closeArticle = useCallback(() => setActiveSlug(null), []);

  const value = useMemo(() => ({ openArticle, closeArticle }), [openArticle, closeArticle]);

  return (
    <ArticleReaderContext.Provider value={value}>
      {children}
      <ArticleReaderModal slug={activeSlug} onClose={closeArticle} onOpenArticle={openArticle} />
      <LearningCompletionPrompt />
    </ArticleReaderContext.Provider>
  );
}